import { Typography } from "@mui/material";
import { paletteColors } from "../muiTheme";
import styled from "@emotion/styled";

const Header = styled(Typography)({
  lineHeight: 1.5,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  maxWidth: "100%",
  fontWeight: "normal",
});

export const HeaderText = styled(Header)({
  fontSize: "2.25rem",
});

export const ImportantHeader = styled(HeaderText)({
  fontWeight: "bold",
  textDecoration: "underline 0.25rem " + paletteColors.primary.main,
});

export const InlineImportantHeader = styled(ImportantHeader)({
  display: "inline",
});

export const SubHeaderText = styled(Header)({
  fontSize: "1rem",
});

export const Title = styled(Header)({
  fontSize: "14px",
});

export const BoldSubHeaderText = styled(SubHeaderText)({
  fontWeight: "bold",
});


export const ModalHeader =styled(HeaderText)({
  fontWeight: 600,
  fontSize: "1.5rem",
  lineHeight: 1.5,
});
